import React from "react";
import UpdateTransactionStatus from "modules/transactions/components/UpdateTransactionStatus";

const UpdateTransactionStatusPage = () => {
  return <UpdateTransactionStatus />;
};

export default UpdateTransactionStatusPage;